import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { legalService, LegalDocument, LegalDocumentType } from '@/services/legalService'
import Markdown from '@/components/legal/Markdown'

interface LegalPageProps {
    type: LegalDocumentType
}

/** Página pública que muestra un documento legal vigente (/terms, /privacy). */
export default function LegalPage({ type }: LegalPageProps) {
    const [doc, setDoc] = useState<LegalDocument | null>(null)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        let active = true
        legalService
            .getDocument(type)
            .then((d) => active && setDoc(d))
            .catch(() => active && setError('No se pudo cargar el documento.'))
        return () => {
            active = false
        }
    }, [type])

    return (
        <div className="min-h-screen bg-gray-900 text-gray-100 py-8 px-4">
            <div className="max-w-3xl mx-auto">
                <Link to="/login" className="inline-flex items-center gap-2 text-indigo-400 hover:text-indigo-300 mb-6">
                    <ArrowLeft size={16} /> Volver
                </Link>

                {error && <p className="text-red-400">{error}</p>}
                {!doc && !error && <p className="text-gray-400">Cargando…</p>}

                {doc && (
                    <article className="bg-gray-800/40 rounded-lg p-6 border border-gray-700">
                        <Markdown content={doc.content} />
                        <p className="mt-8 pt-4 border-t border-gray-700 text-xs text-gray-500">
                            Versión {doc.version} · hash {doc.hash.slice(0, 16)}…
                        </p>
                    </article>
                )}
            </div>
        </div>
    )
}
